// Generate jobs schema
// This will create the script tag that goes inside of the Main Helmet
import places from './places'

const fillTemplate = ({ city, state }) => {
  return {
    "@type": "JobPosting",
    "baseSalary" : {
      "@type": "MonetaryAmount",
      "currency": "USD",
      "value": {
        "@type": "QuantitativeValue",
        "minValue": 100.00,
        "maxValue": 200.00,
        "unitText": "HOUR"
      }
    },
    "datePosted": new Date().toISOString().slice(0,10),
    "employmentType" : "CONTRACTOR",
    "hiringOrganization" : {
      "@type" : "Organization",
      "name" : "OnCallogy",
      "sameAs" : "https://www.oncallogy.com"
    },
    "jobLocation" : {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": city,
        "addressRegion": state,
        "addressCountry": "US"
      }
    },
    "description": "OnCallogy is an app that allows physicians to find local moonlighting shifts. Register at www.oncallogy.com and find moonlighting opportunities near you today.",
    "title": `Moonlighting Physician in ${city}, ${state}`
  }
}

export default () => {
  const postings = []
  places.map(place => {
    postings.push(fillTemplate(place))
  })
  return {
    "type": "application/ld+json",
    "innerHTML": JSON.stringify({
      "@context": "https://schema.org",
      "@graph": postings
    })
  }
}




// WEBPACK FOOTER //
// ./src/lib/jobs.js